export const apiURL = process.env.REACT_APP_API_URL;
export const swpcURL = process.env.REACT_APP_SWPC_URL;
export const vapidKey = process.env.REACT_APP_VAPID_KEY;
